import { SAlert, SListTabs } from 'shj-components'
import { useSetState } from 'ahooks'
import { useEffect } from 'react'

import PriceList from './tableList.tsx'
import { getProductEnums } from '@/services/product.ts'
import { useSearchParams } from 'react-router-dom'
import { KeepAlive } from 'react-activation';

function PriceTagManage() {
  const [searchParams] = useSearchParams()
  const type = searchParams.get('type')
  const [state, setState] = useSetState<any>({
    tabList: [],
    active: '',
  })

  useEffect(() => {
    getTabList()
  }, [])

  const getTabList = async () => {
    let data = await getProductEnums('com.shj.saas.plus.product.enums.CostTypeEnum')
    data = [{ key: 'FEES_TEMPLATE', description: '费用模板' }, ...data, { key: 'BREAK_MANAGE', description: '违约金' }]
    const remarkObj = {
      COST_BUDGET: '',
      COST_DESIGN: '用于管理报价中设计相关的各种费用，例如：设计费等。',
      COST_DISCOUNT:
        '用于管理报价中优惠相关的各种费用以及子费用的管理，例如：现金优惠、软装优惠、活动打折等。',
      COST_OTHERS:
        '',
      BREAK_MANAGE:
        '违约金模块专门针对开工前退单违约金比例进行设置，默认以下需求标签所有产品使用，无需在新建产品时加入费用项。违约金=订单工程总造价*违约金比例，最高比例默认不超过10%。退单时，填写比例大于最低比例，可发起；填写比例小于最低比例，若公司违约金率非空，则需继续判断加上当笔退单，公司违约金率是否低于设置比例，低于设置比例不可发起，高于可发起。特殊：开启异常退单后，可不限制违约金。',
    }
    const tabList = data.map(item => ({
      key: item.key,
      label: item.description,
      children: (
        <>
          {remarkObj[item.key] && (
            <div style={{ marginTop: 10, }}>
              <SAlert type='info'> {'说明：' + remarkObj[item.key]}</SAlert>
            </div>
    
          )}
          <PriceList type={item.key} />
        </>
      ),
    }))

    setState({ tabList, active: type || tabList[0]?.key })
  }

  return (
    <div>
      <SListTabs
        activeKey={state.active}
        onChange={key => setState({ active: key })}
        auth={true}
        items={state.tabList}
      />
    </div>
  )
}

export default function PriceTagManagePage() {
  return(
    <KeepAlive name={location.pathname}>
      <PriceTagManage />
    </KeepAlive>
  )
}
